module.exports = __webpack_public_path__ + "media/images/club-logo/8-11dfffc78bdbfbd9690c9c4d9656d487.png";